<template>
  <v-row>
    <v-col class="pb-0" cols="12">
      <b-select
        v-model="internalDepartment.parentId"
        :items="$directory.get('internalDepartments')"
        :loading="$loading.isLoading('internalDepartments')"
        label="Батьківський підрозділ"
        placeholder="Оберіть зі списку" />
    </v-col>
    <v-col class="pt-0 pb-0" cols="12">
      <b-select
        v-model="internalDepartment.departmentTypeId"
        :error-messages="getErrorMessages(v$.departmentTypeId)"
        :items="$directory.get('orgDepartmentTypes')"
        :loading="$loading.isLoading('orgDepartmentTypes')"
        label="Тип підрозділу"
        placeholder="Оберіть зі списку"
        @blur="v$.departmentTypeId.$touch()" />
    </v-col>
    <v-col class="pt-0 pb-0" cols="12" md="6">
      <b-input
        v-model="internalDepartment.internalCode"
        :error-messages="getErrorMessages(v$.internalCode)"
        label="Внутрішній код"
        placeholder="Наприклад 03.01"
        @blur="v$.internalCode.$touch()" />
    </v-col>
    <v-col class="pt-0 pb-0" cols="12" md="6">
      <b-input
        v-model="internalDepartment.name"
        :error-messages="getErrorMessages(v$.name)"
        label="Назва підрозділу"
        placeholder="Введіть назву"
        @blur="v$.name.$touch()" />
    </v-col>
    <v-col class="pt-0 pb-0" cols="12">
      <b-textarea
        v-model="internalDepartment.description"
        label="Опис підрозділу"
        placeholder="Короткий опис функцій або призначення підрозділу" />
    </v-col>
    <v-col v-if="isUpdate" class="pt-0" cols="12">
      <v-checkbox
        v-model="internalDepartment.isActive"
        :false-value="true"
        :true-value="false"
        label="Заблокований" />
    </v-col>
  </v-row>
</template>
<script lang="ts">
import { reactive } from 'vue'
import { required, useVuelidate } from '@/plugins'
import { getErrorMessages } from '@/utils/helpers'
import { setSnackbar } from 'best-modules/plugins'
import { clearDirectory, fillDirectory } from '@/directory/index.ts'
import { BTextarea } from 'best-modules/components'
import {
  internalDepartmentCreate,
  internalDepartmentUpdate,
} from '@/requests/internalDepartment'
import { InternalDepartmentCredentials } from '@/utils/types/internalDepartment'

export default {
  name: 'InternalDepartmentDialog',
  components: { BTextarea },
  props: {
    dialog: { type: Object, required: true },
  },
  methods: { getErrorMessages },
  async setup(props) {
    await fillDirectory(['internalDepartments', 'orgDepartmentTypes'])

    const isUpdate = props.dialog.action === 'update'
    const itemData = props.dialog.dialogData?.itemData

    const internalDepartment = reactive<InternalDepartmentCredentials>({
      name: itemData?.name,
      internalCode: itemData?.internalCode,
      parentId: itemData?.parentId,
      departmentTypeId: itemData?.departmentTypeId,
      description: itemData?.description,
      isActive: itemData?.isActive,
    } as InternalDepartmentCredentials)

    const v$ = useVuelidate(
      {
        name: { required },
        internalCode: { required },
        departmentTypeId: { required },
      },
      internalDepartment
    )

    const submit = () => {
      const { isActive: _isActive, ...rest } = internalDepartment
      const payload = isUpdate ? internalDepartment : rest

      const request = isUpdate
        ? internalDepartmentUpdate(itemData?.id, payload)
        : internalDepartmentCreate(payload)

      return request.then(res => {
        setSnackbar({
          text: `Підрозділ ${isUpdate ? 'оновлено' : 'створено'}`,
        })
        clearDirectory('internalDepartments')
        clearDirectory('activeInternalDepartments')
        return res
      })
    }

    return {
      internalDepartment,
      isUpdate,
      v$,
      submit,
      validationScope: 'internalDepartment',
    }
  },
}
</script>
